import { JobType } from '../Enums/teachers.enum';

export const JOB_TYPE_OPTIONS = [
  {
    text: 'Full time',
    value: JobType.FULLTIME,
  },
  {
    text: 'Part time',
    value: JobType.PARTTIME,
  },
];
